import React from 'react';
import '../css/bg.css';
import career from '../images/career_hero_new.png';
import Fresher from '../images/fresher.jpg';
import professional from '../images/professional.jpg';
import leader from '../images/leader.jpg';

export default function Career() {
    return (
        <>
            <div
                className="position-relative d-flex align-items-center justify-content-center text-center overflow-hidden"
                style={{
                    width: '100%',
                    height: '55vh',
                    backgroundImage: `url(${career})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    marginTop: '-1px'
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(135deg, rgba(15,23,42,0.9) 0%, rgba(15,23,42,0.4) 100%)',
                        zIndex: 1
                    }}
                />
                <div className="container position-relative px-4" style={{ zIndex: 2 }}>
                    <p className="section-label animate-fade-up text-info mb-3">Join the Innovation</p>
                    <h1 className="text-white fw-bold animate-fade-up delay-1" style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', lineHeight: 1.1 }}>
                        BUILD THE <span className="text-info">FUTURE</span>
                    </h1>
                    <p className="animate-fade-up delay-2 text-white-50 mt-4 mx-auto" style={{ maxWidth: '650px', fontSize: '1.2rem', lineHeight: 1.6 }}>
                        We're looking for bold thinkers and creative problem solvers to help us redefine what's possible in the world of technology.
                    </p>
                </div>
            </div>

            <div className="py-6" style={{ background: 'var(--ftb-bg-alt)', transition: 'var(--transition)', padding: '80px 20px' }}>
                <div className="container text-center">
                    <h2 className="section-title mb-4">COME & JOIN US</h2>
                    <p className='section-subtitle mb-3'>
                        We’re looking for software engineers who want to invent, build, and sometimes break things to make them easier, faster, better,
                        and more cost-effective.
                    </p>
                    <p className='section-subtitle mb-3'>
                        To those who thrive at solving highly complex problems, and who aspire to impact billions of lives on a global scale: come build the future with us.
                    </p>
                    <p className='section-subtitle'>
                        Come and collaborate with our client to provide <strong>Software Development </strong>Services.
                    </p>
                </div>
            </div>

            <div className="container py-5 mt-4">
                <p className="section-label text-center">Our Commitment</p>
                <h2 className="section-title text-center">We are here to make a difference</h2>
            </div>

            <div className="container pb-6">
                <div className="row g-4">
                    <div className="col-lg-4">
                        <div className="ftb-service-card h-100">
                            <img src={Fresher} className="card-img-top" alt="fresher" style={{ height: '220px', objectFit: 'cover' }} />
                            <div className="p-4">
                                <div className="ftb-card-accent mb-3" />
                                <h5 className="fw-bold mb-3">Graduates / Interns</h5>
                                <p className="section-subtitle" style={{ fontSize: '0.95rem', textAlign: 'left' }}>
                                    Start your fresh and early career with us. We have a great workplace for your career.
                                    Start your journey as an <strong>intern</strong> to learn and explore our domains and Services.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="ftb-service-card h-100">
                            <img src={professional} className="card-img-top" alt="professional" style={{ height: '220px', objectFit: 'cover' }} />
                            <div className="p-4">
                                <div className="ftb-card-accent mb-3" />
                                <h5 className="fw-bold mb-3">Professionals</h5>
                                <p className="section-subtitle" style={{ fontSize: '0.95rem', textAlign: 'left' }}>
                                    Bring your <strong>professional experience</strong> to our workplace. Let your expertise move to the next level to innovate with global clients.
                                    Take meaningful steps for your future with us.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="ftb-service-card h-100">
                            <img src={leader} className="card-img-top" alt="leader" style={{ height: '220px', objectFit: 'cover' }} />
                            <div className="p-4">
                                <div className="ftb-card-accent mb-3" />
                                <h5 className="fw-bold mb-3">Executives</h5>
                                <p className="section-subtitle" style={{ fontSize: '0.95rem', textAlign: 'left' }}>
                                    You are the <strong>leader/expert</strong> we’re looking for. Passionate about professional development and building a spirit of innovation in a team's DNA? Apply now.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-light" >
                <div className="container-fluid">
                    <div className="row pt-4" style={{ width: '100%' }}>
                        <h3 className='section-title text-center mb-4'>Share Your Resume</h3>
                        <div className="pt-3" style={{ width: '100%' }}>
                            <iframe title="resume" style={{ height: '95vh', width: '100%' }} src='https://forms.zohopublic.in/ftbinnosphere/form/ApplyOnline/formperma/lvdOC7dcLMm1xeJeZmmNPdb7-RLMHLb-5lAp7WNjnd0'></iframe>

                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}
